/* import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyAPI } from "../services/api"; */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyAPI, AuthAPI } from "../services/api";

export default function RegisterNewCompany() {
  const navigate = useNavigate();

  const [user, setUser] = useState({
 
  email: "",
});

useEffect(() => {
  const loadUser = async () => {
    try {
      const response = await AuthAPI.me();

      setUser({
        email: response.data.email || "",
      });
    } catch (err) {
      console.error("Failed to load user details:", err);
      setError("Unable to load user details.");
    }
  };

  loadUser();
}, []);

  const [form, setForm] = useState({
    clientName: "",
    description: "",
    contactPerson: "",
    companyWebsite: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    if (!form.clientName.trim()) {
      setError("Company name is required.");
      return;
    }

    try {
      setSaving(true);

      const response =
        await CompanyAPI.registerExistingUserCompany({
          clientName: form.clientName,
          description: form.description,
          contactPerson: form.contactPerson,
          companyWebsite: form.companyWebsite,
        });

      console.log("New company response:", response.data);

      setSuccess("New company registered successfully.");

      setTimeout(() => {
        navigate("/");
      }, 1200);

    } catch (err: any) {
      console.error(err);

      setError(
        err?.response?.data?.message ||
        "Failed to register new company."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f5f6fa",
        padding: "30px",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          margin: "0 auto",
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            color: "#53538c",
            marginBottom: "25px",
          }}
        >
          Register New Company
        </h2>

        {error && (
          <div
            style={{
              background: "#ffecec",
              color: "#c62828",
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
            }}
          >
            {error}
          </div>
        )}

        {success && (
          <div
            style={{
              background: "#eaf7ea",
              color: "#2e7d32",
              padding: "10px",
              marginBottom: "15px",
              borderRadius: "5px",
            }}
          >
            {success}
          </div>
        )}

        <form onSubmit={handleSubmit}>


            {/* EMAIL */}
<div style={{ marginBottom: "15px" }}>
  <label>Email</label>

  <input
    type="email"
    value={user.email}
    readOnly
    style={{
      width: "100%",
      padding: "10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      background: "#f1f1f1",
      color: "#555",
      cursor: "not-allowed",
    }}
  />
</div>

{/* PASSWORD */}
<div style={{ marginBottom: "15px" }}>
  <label>Password</label>

  <input
    type="password"
    value="********"
    readOnly
    style={{
      width: "100%",
      padding: "10px",
      marginTop: "5px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      background: "#f1f1f1",
      color: "#555",
      cursor: "not-allowed",
    }}
  />
</div>

          {/* COMPANY NAME */}
          <div style={{ marginBottom: "15px" }}>
            <label>
              Company Name <span style={{ color: "red" }}>*</span>
            </label>

            <input
              type="text"
              name="clientName"
              value={form.clientName}
              onChange={handleChange}
              placeholder="Enter company name"
              required
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>

          {/* DESCRIPTION */}
          <div style={{ marginBottom: "15px" }}>
            <label>Description</label>

            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Enter company description"
              rows={4}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                resize: "vertical",
              }}
            />
          </div>

          {/* CONTACT PERSON */}
          <div style={{ marginBottom: "15px" }}>
            <label>Contact Person</label>

            <input
              type="text"
              name="contactPerson"
              value={form.contactPerson}
              onChange={handleChange}
              placeholder="Enter contact person"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>

          {/* COMPANY WEBSITE */}
          <div style={{ marginBottom: "25px" }}>
            <label>Company Website</label>

            <input
              type="text"
              name="companyWebsite"
              value={form.companyWebsite}
              onChange={handleChange}
              placeholder="https://example.com"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "5px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>

          {/* BUTTONS */}
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <button
              type="button"
              onClick={() => navigate("/")}
              style={{
                padding: "10px 20px",
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>

            <button
              type="submit"
              disabled={saving}
              style={{
                padding: "10px 20px",
                background: "#53538c",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: saving ? "not-allowed" : "pointer",
              }}
            >
              {saving ? "Registering..." : "Register Company"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}